import * as React from "react"

export default function CalendarSolidIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.333 7.333h13.334v6A.667.667 0 0114 14H2a.667.667 0 01-.667-.667v-6zm10-5.333H14a.667.667 0 01.667.667V6H1.333V2.667A.667.667 0 012 2h2.667V.667H6V2h4V.667h1.333V2z"
        fill={props.fill}
      />
    </svg>
  )
}
